"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PharmacyCreation = void 0;
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const enums_1 = require("../../../../enums");
const Breakpoints_1 = require("../../../../helper/Breakpoints");
const GlobalStyles_1 = require("../../../../helper/GlobalStyles");
const atome_1 = require("../../../atome");
const Button_1 = __importDefault(require("../../../atome/Button/Button"));
const PharmacyCreation_styles_1 = require("./PharmacyCreation.styles");
const PharmacyCreation = ({ navigation }) => {
    const [name, setName] = (0, react_1.useState)('');
    const [street, setStreet] = (0, react_1.useState)('');
    const [houseNumber, setHouseNumber] = (0, react_1.useState)('');
    const [postcode, setPostcode] = (0, react_1.useState)('');
    const [phone, setPhone] = (0, react_1.useState)('');
    const [city, setCity] = (0, react_1.useState)('');
    const [error, setError] = (0, react_1.useState)({
        name: false,
        street: false,
        houseNumber: false,
        postcode: false,
        phone: false,
        phoneShort: false,
        phoneLong: false,
        city: false,
    });
    const pharmacy = {
        id: undefined,
        name: name,
        street: street,
        houseNumber: houseNumber,
        postcode: postcode,
        phone: phone,
        city: city,
    };
    const validate = async () => {
        const newError = {
            name: name === '',
            street: street === '',
            houseNumber: houseNumber === '',
            postcode: postcode === '',
            phone: phone === '',
            phoneShort: phone.length < 6 && phone !== '',
            phoneLong: phone.length > 17,
            city: city === '',
        };
        setError(newError);
        return newError;
    };
    const clickNext = async () => {
        let newError = await validate();
        if (Object.values(newError).every(value => value === false)) {
            navigation.navigate('PharmacyConfirmation', {
                chosenPharmacy: pharmacy,
            });
        }
    };
    return (react_1.default.createElement(atome_1.ProtectedPage, { navigation: navigation },
        react_1.default.createElement(react_native_1.SafeAreaView, { style: [PharmacyCreation_styles_1.styles.whiteBackground] },
            react_1.default.createElement(react_native_1.ScrollView, null,
                react_1.default.createElement(react_native_1.View, { style: PharmacyCreation_styles_1.styles.container },
                    react_1.default.createElement(react_native_1.View, { style: PharmacyCreation_styles_1.styles.textView },
                        react_1.default.createElement(atome_1.Icon, { icon: "pharmacy", size: 90 }),
                        react_1.default.createElement(atome_1.Text, { style: [PharmacyCreation_styles_1.styles.heading3Green] }, "Eigene Apotheke eingeben"),
                        react_1.default.createElement(atome_1.Text, { style: [PharmacyCreation_styles_1.styles.heading4] }, "Bitte geben Sie die Details Ihrer Apotheke ein.")),
                    react_1.default.createElement(react_native_1.View, { style: { flexDirection: 'row', marginVertical: 15 } },
                        react_1.default.createElement(react_native_1.View, { style: [GlobalStyles_1.globalStyles.flex2] },
                            react_1.default.createElement(atome_1.Text, { style: [PharmacyCreation_styles_1.styles.heading3Black] }, "Name der Apotheke"),
                            react_1.default.createElement(atome_1.Text, { style: [PharmacyCreation_styles_1.styles.label] }, "Bitte geben Sie den Namen der Apotheke an."),
                            react_1.default.createElement(atome_1.InputField, { onChange: setName, value: name, style: Breakpoints_1.isMobile || Breakpoints_1.isTablet ? [PharmacyCreation_styles_1.styles.input] : undefined }),
                            react_1.default.createElement(react_native_1.View, null, error.name ? (react_1.default.createElement(atome_1.Text, { style: [PharmacyCreation_styles_1.styles.redText] }, enums_1.ErrorMessages.EMPTY_FIELD)) : null))),
                    react_1.default.createElement(react_native_1.View, { style: { flexDirection: 'row', marginTop: 15, height: 'auto' } },
                        react_1.default.createElement(react_native_1.View, { style: [GlobalStyles_1.globalStyles.flex2] },
                            react_1.default.createElement(atome_1.Text, { style: [PharmacyCreation_styles_1.styles.heading3Black] }, "Adresse / Kontakt"),
                            react_1.default.createElement(atome_1.Text, { style: [PharmacyCreation_styles_1.styles.heading4] }, "Bitte geben Sie die Anschrift und Telefonnummer der Apotheke an."),
                            react_1.default.createElement(react_native_1.View, { style: {
                                    flexDirection: 'row',
                                    marginBottom: 10,
                                    marginTop: 20,
                                    height: 'auto',
                                    justifyContent: 'space-between',
                                } },
                                react_1.default.createElement(react_native_1.View, { style: { flexDirection: 'column', width: '65%' } },
                                    react_1.default.createElement(react_native_1.View, { style: [{ flexShrink: 2 }] },
                                        react_1.default.createElement(atome_1.Text, { style: [PharmacyCreation_styles_1.styles.label] }, "Stra\u00DFe"),
                                        react_1.default.createElement(atome_1.InputField, { onChange: setStreet, value: street, style: Breakpoints_1.isMobile || Breakpoints_1.isTablet ? [PharmacyCreation_styles_1.styles.input] : undefined })),
                                    react_1.default.createElement(react_native_1.View, { style: { flexDirection: 'row', height: 'auto' } }, error.street ? (react_1.default.createElement(atome_1.Text, { style: [PharmacyCreation_styles_1.styles.redText] }, enums_1.ErrorMessages.EMPTY_FIELD)) : null)),
                                react_1.default.createElement(react_native_1.View, { style: {
                                        flexDirection: 'column',
                                        width: '30%',
                                        height: 'auto',
                                    } },
                                    react_1.default.createElement(react_native_1.View, { style: [{ flexShrink: 2 }] },
                                        react_1.default.createElement(atome_1.Text, { style: [PharmacyCreation_styles_1.styles.label] }, "Hausnummer"),
                                        react_1.default.createElement(atome_1.InputField, { onChange: setHouseNumber, value: houseNumber, style: Breakpoints_1.isMobile || Breakpoints_1.isTablet ? [PharmacyCreation_styles_1.styles.input] : undefined })),
                                    react_1.default.createElement(react_native_1.View, { style: { flexDirection: 'row', height: 'auto' } }, error.houseNumber ? (react_1.default.createElement(atome_1.Text, { style: [PharmacyCreation_styles_1.styles.redText] }, enums_1.ErrorMessages.EMPTY_FIELD)) : null))))),
                    react_1.default.createElement(react_native_1.View, { style: { flexDirection: 'row', height: 'auto' } },
                        react_1.default.createElement(react_native_1.View, { style: [GlobalStyles_1.globalStyles.flex2] },
                            react_1.default.createElement(react_native_1.View, { style: {
                                    flexDirection: 'row',
                                    marginVertical: 10,
                                    height: 'auto',
                                    justifyContent: 'space-between',
                                } },
                                react_1.default.createElement(react_native_1.View, { style: { flexDirection: 'column', width: '35%' } },
                                    react_1.default.createElement(react_native_1.View, { style: [{ flexShrink: 2 }] },
                                        react_1.default.createElement(atome_1.Text, { style: [PharmacyCreation_styles_1.styles.label] }, "PLZ"),
                                        react_1.default.createElement(atome_1.InputField, { onChange: setPostcode, value: postcode, style: Breakpoints_1.isMobile || Breakpoints_1.isTablet ? [PharmacyCreation_styles_1.styles.input] : undefined })),
                                    react_1.default.createElement(react_native_1.View, null, error.postcode ? (react_1.default.createElement(atome_1.Text, { style: [PharmacyCreation_styles_1.styles.redText] }, enums_1.ErrorMessages.EMPTY_FIELD)) : null)),
                                react_1.default.createElement(react_native_1.View, { style: { flexDirection: 'column', width: '60%' } },
                                    react_1.default.createElement(react_native_1.View, { style: [{ flexShrink: 2 }] },
                                        react_1.default.createElement(atome_1.Text, { style: [PharmacyCreation_styles_1.styles.label] }, "Ort"),
                                        react_1.default.createElement(atome_1.InputField, { onChange: setCity, value: city, style: Breakpoints_1.isMobile || Breakpoints_1.isTablet ? [PharmacyCreation_styles_1.styles.input] : undefined })),
                                    react_1.default.createElement(react_native_1.View, null, error.city ? (react_1.default.createElement(atome_1.Text, { style: [PharmacyCreation_styles_1.styles.redText] }, enums_1.ErrorMessages.EMPTY_FIELD)) : null))))),
                    react_1.default.createElement(react_native_1.View, { style: { flexDirection: 'row', marginVertical: 10 } },
                        react_1.default.createElement(react_native_1.View, { style: [GlobalStyles_1.globalStyles.flex2] },
                            react_1.default.createElement(atome_1.Text, { style: [PharmacyCreation_styles_1.styles.label] }, "Telefonnummer"),
                            react_1.default.createElement(atome_1.InputField, { onChange: setPhone, value: phone, style: Breakpoints_1.isMobile || Breakpoints_1.isTablet ? [PharmacyCreation_styles_1.styles.input] : undefined }),
                            react_1.default.createElement(react_native_1.View, null, error.phone || error.phoneShort || error.phoneLong ? (react_1.default.createElement(atome_1.Text, { style: [PharmacyCreation_styles_1.styles.redText] },
                                error.phone && enums_1.ErrorMessages.PHONE_EMPTY,
                                error.phoneShort && enums_1.ErrorMessages.PHONE_SHORT,
                                error.phoneLong && enums_1.ErrorMessages.PHONE_LONG)) : null))),
                    react_1.default.createElement(react_native_1.View, { style: PharmacyCreation_styles_1.styles.buttonSave },
                        react_1.default.createElement(Button_1.default, { type: 'primary', text: 'Weiter', onClick: clickNext })))))));
};
exports.PharmacyCreation = PharmacyCreation;
